import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import authApi from '~/authApi';
import { USER_ROLES } from '~/constants';
import { agencyRoutes } from '~/core/router/groups';
import useIsSharedPage from '~/hooks/useIsSharedPage';

const useForbiddenQuery = (query) => {
  const queryClient = useQueryClient();
  const { roles } = authApi.user;
  const isSharedPage = useIsSharedPage();
  const router = useRouter();
  if (
    query?.error?.response?.status === 403 &&
    roles.includes(USER_ROLES.talentManager)
  ) {
    router.push(agencyRoutes.agencyTalent);
  }

  if (query?.error?.response?.status === 401 && isSharedPage) {
    queryClient.clear();
    router.push(
      `/shared/login?redirectToAs=${router.asPath}&redirectToHref=${router.pathname}&sharedToken=${router.query.sharedToken}`,
    );
  }
  return query;
};

export default useForbiddenQuery;
